import {
  LOAD_FILE,
  SAVE_FILE,
  CHANGE_FILE_NAME,
  LOAD_FILE_DIALOG,
  EDIT_VALUES,
  CREATE_NEW_FILE,
  ADD_DRIVE,
  REMOVE_DRIVE,
  MOVE_DRIVES,
  INSERT_PICKS,
  REMOVE_PICKS,
  REMOVE_PICKS_FROM_SELECTION,
  SET_DATA,
  SET_AVAILABLE_FILES,
  SET_EDIT_VALUES,
  RESET_STATE,
  FILE_SAVED,
  SET_MODIFIED,
  SET_FILE_NAME,
  SET_EDITABLE,
  SET_FILE_TYPE,
  EDIT_SHAFT_JACQUARD,
  SET_SHAFT_JACQUARD,
  TOGGLE_REGULATOR,
  SET_REGULATOR,
  SET_CPPP,
  SET_DATA_AVAILABLE,
  FILE_MODIFIED
} from "./constants";
import { RESET_ZOOM } from "../tableView/constants";

import {
  getFileContent,
  getAvailableFiles,
  isExistingFile,
  saveFile
} from "./apiCalls";

import {
  successNotification,
  errorNotification,
  warningNotification
} from "../notifications/helper";
import { NEW_BUTTON_SELECTION_DIALOG } from "../buttonSelectionDialog/constants.js";
import { NEW_OK_CANCEL_DIALOG } from "../okCancelDialog/constants.js";
import {
  SHOW_PROGRESS,
  HIDE_PROGRESS
} from "../progressComponent/constants.js";
import { SET_HMT } from "../settings/constants.js";
import { pickTypesSettings } from "../../../src/utils/tableEditorHeaderHelper.js";

const _ = require("lodash");
import eventBus from "../../../src/utils/eventBus";

import axios from "../../../src/utils/axiosInstance";

const regex = /^(uptData\/)/;

const _LOAD_FILE = LOAD_FILE.replace(regex, "");
const _SAVE_FILE = SAVE_FILE.replace(regex, "");
const _CHANGE_FILE_NAME = CHANGE_FILE_NAME.replace(regex, "");
const _LOAD_FILE_DIALOG = LOAD_FILE_DIALOG.replace(regex, "");
const _CREATE_NEW_FILE = CREATE_NEW_FILE.replace(regex, "");
const _EDIT_VALUES = EDIT_VALUES.replace(regex, "");
const _ADD_DRIVE = ADD_DRIVE.replace(regex, "");
const _REMOVE_DRIVE = REMOVE_DRIVE.replace(regex, "");
const _MOVE_DRIVES = MOVE_DRIVES.replace(regex, "");
const _INSERT_PICKS = INSERT_PICKS.replace(regex, "");
const _REMOVE_PICKS = REMOVE_PICKS.replace(regex, "");
const _REMOVE_PICKS_FROM_SELECTION = REMOVE_PICKS_FROM_SELECTION.replace(
  regex,
  ""
);
const _EDIT_SHAFT_JACQUARD = EDIT_SHAFT_JACQUARD.replace(regex, "");
const _TOGGLE_REGULATOR = TOGGLE_REGULATOR.replace(regex, "");
const _FILE_MODIFIED = FILE_MODIFIED.replace(regex, "");

import { useUptWorker } from "../../../src/utils/webWorker";
import colorStore from "../../../src/utils/colorControlColors";
import { NEW_GENERIC_INPUT_DIALOG } from "../genericInputDialog/constants";
import uptFile from "../../../src/utils/nonReactiveState/uptFile";
import { unitConverter } from "../../../src/utils/unitConverter.js";
import selection from "../../../src/utils/nonReactiveState/selection";

export default {
  [_CHANGE_FILE_NAME]({ commit }, fileName) {
    commit(SET_FILE_NAME, fileName);
  },

  async [_LOAD_FILE]({ commit, dispatch }, { path, specificCustomerId }) {
    try {
      dispatch(SHOW_PROGRESS, "Loading file...", { root: true });
      const fileContent = await getFileContent(path, specificCustomerId);
      if (!_.isNil(fileContent) && !_.isEmpty(fileContent)) {
        commit(RESET_STATE);
        uptFile.reset();
        selection.resetSelection(true);
        dispatch(RESET_ZOOM, null, { root: true });
        const splittedFile = await useUptWorker("splitPickData", [fileContent]);
        let fileIsInvalid = false;
        splittedFile.pickData.driveData.tagNames.forEach(tag => {
          if (_.isNil(pickTypesSettings[tag].name)) {
            fileIsInvalid = true;
          }
        });
        if (fileIsInvalid) {
          errorNotification("This file type is not yet supported.");
          dispatch(HIDE_PROGRESS, null, { root: true });
          return;
        }
        if (fileContent.fileType !== "upt128") {
          warningNotification(
            "File type is not upt 128. You will not be able to save this file in its original format."
          );
        }
        commit(SET_FILE_TYPE, fileContent.fileType);
        if (splittedFile.pickData.colorControl.data.length !== 0) {
          commit(SET_EDITABLE, {
            editDrives: true,
            editJacquard: true,
            editShaft: true,
            editColorControl: true,
            editPicks: false,
            editHooks: true,
            canSelect: true,
            canSave: true
          });
        }
        colorStore.initialize();
        _.forEach(fileContent.pickData.customColors, (value, key) =>
          colorStore.setColor(key, value)
        );
        const useHmt = splittedFile.pickData.shaftData.data
          .map(p => p.includes(1) || p.includes(2))
          .includes(true);
        dispatch(SET_HMT, useHmt, { root: true });
        if (splittedFile.pickData.driveData.data.length !== 0) {
          const headerTypes = splittedFile.pickData.driveData.tagNames.map(
            t => pickTypesSettings[t]
          );
          const convertedDriveData = splittedFile.pickData.driveData.data.map(
            d => {
              return d.map((driveItem, driveIndex) => {
                return unitConverter.convertValue(
                  driveItem,
                  headerTypes[driveIndex].saveUnit,
                  headerTypes[driveIndex].showUnit
                );
              });
            }
          );
          splittedFile.pickData.driveData.data = convertedDriveData;
        }
        commit(SET_FILE_NAME, path);
        commit(SET_DATA, splittedFile);
        commit(SET_MODIFIED, false);
        successNotification("File loaded successfully.");
        eventBus.$emit("fileLoaded");
      } else {
        errorNotification("File could not be loaded.");
      }
    } catch (err) {
      errorNotification("File could not be loaded.");
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
  },

  [_EDIT_VALUES]({ commit }, { values, selections, notification = true }) {
    const takeOffIndex = uptFile.pickData.driveData.tagNames.indexOf(
      "PickDensityPer100m"
    );
    const hasColorControl = uptFile.pickData.colorControl.data.length !== 0;
    if (!(takeOffIndex !== -1 && hasColorControl)) {
      commit(SET_EDIT_VALUES, { values, selections });
      if (notification) {
        successNotification("Values changed.");
      }
    } else {
      const zipped = _.zip(values, selections);
      const packetValues = zipped.filter(z => z[1][1] === takeOffIndex);
      const otherValues = zipped.filter(z => z[1][1] !== takeOffIndex);
      const expandedValues = [];
      packetValues.forEach(p => {
        const packet = getPickIndexesOfPacket(uptFile, p[1][0]);
        const packetIsNotInList = expandedValues.findIndex(
          e => e[1] === packet[0]
        );
        if (packetIsNotInList === -1) {
          expandedValues.push(...packet.map(m => [p[0], m, p[1][1]]));
        }
      });
      expandedValues.push(...otherValues.map(m => [m[0], m[1][0], m[1][1]]));
      const newValues = expandedValues.map(e => e[0]);
      const newSelections = expandedValues.map(e => [e[1], e[2]]);
      commit(SET_EDIT_VALUES, { values: newValues, selections: newSelections });
      if (notification) {
        successNotification("Values changed.");
      }
    }
  },

  async [_LOAD_FILE_DIALOG]({ state, commit, dispatch }) {
    dispatch(SHOW_PROGRESS, "Loading available files...", {
      root: true
    });
    commit(SET_AVAILABLE_FILES, await getAvailableFiles());
    dispatch(HIDE_PROGRESS, null, { root: true });
    const fileSelection = await dispatch(
      NEW_BUTTON_SELECTION_DIALOG,
      {
        title: "Load a file",
        selection: state.availableFiles,
        hasFilter: true,
        icon: "cloud_download"
      },
      { root: true }
    );
    if (fileSelection.cancelled) {
      return;
    }
    await dispatch(_LOAD_FILE, { path: fileSelection.result });
  },

  async [_SAVE_FILE]({ commit, state, rootState, dispatch }) {
    try {
      let fileName;
      let override;
      if (!rootState.settings.redirectAfterSave) {
        const fileTypes = ["upt128"]; // "upt51", "upt30"
        let initialFileType;
        if (fileTypes.includes(state.fileType)) {
          initialFileType = state.fileType;
        } else {
          initialFileType = "upt128";
        }
        const dialogResult = await dispatch(
          NEW_GENERIC_INPUT_DIALOG,
          {
            title: "Save file as...",
            icon: "cloud_upload",
            autofocus: "fileName",
            content: [
              {
                id: "fileName",
                type: "textInput",
                initialValue: state.fileName,
                inputLabel: "Filename",
                createValidationErrorMessage: s => {
                  if (s.includes(".")) {
                    return "File can not contain '.'";
                  }
                  return "";
                },
                append: ".UPT"
              },
              {
                id: "fileType",
                type: "dropdown",
                initialValue: initialFileType,
                inputLabel: "Filetype",
                dropdownSelection: fileTypes,
                createValidationErrorMessage: s => {
                  if (!s) {
                    return "File type can not be empty";
                  }
                  return "";
                }
              }
            ]
          },
          { root: true }
        );
        fileName = dialogResult.fileName;
        if (dialogResult.cancelled) {
          return false;
        }
        commit(SET_FILE_NAME, fileName);
        commit(SET_FILE_TYPE, dialogResult.fileType);
        dispatch(SHOW_PROGRESS, "Checking file name...", {
          root: true
        });
        let isExisting;
        try {
          isExisting = await isExistingFile(fileName);
        } catch (err) {
          errorNotification(
            "Could not check if file exists. Please try again."
          );
          dispatch(HIDE_PROGRESS, null, { root: true });
          return false;
        }
        dispatch(HIDE_PROGRESS, null, { root: true });
        override = false;
        if (isExisting) {
          override = await dispatch(
            NEW_OK_CANCEL_DIALOG,
            {
              title: "File already exists",
              text: `A file with the name "${fileName}" already exists. Do you want to override this file?`,
              okText: "Yes",
              cancelText: "No",
              icon: "warning"
            },
            { root: true }
          );
          if (!override) {
            return false;
          }
        }
      } else {
        fileName = rootState.settings.fileToEdit;
        override = true;
      }

      const uptFileCopy = _.cloneDeep(uptFile);

      if (uptFileCopy.pickData.driveData.data.length !== 0) {
        const headerTypes = uptFileCopy.pickData.driveData.tagNames.map(
          t => pickTypesSettings[t]
        );
        const convertedDriveData = uptFileCopy.pickData.driveData.data.map(
          d => {
            return d.map((driveItem, driveIndex) => {
              return unitConverter.convertValue(
                driveItem,
                headerTypes[driveIndex].showUnit,
                headerTypes[driveIndex].saveUnit
              );
            });
          }
        );
        uptFileCopy.pickData.driveData.data = convertedDriveData;
      }

      const pickData = await useUptWorker("mergePickData", [uptFileCopy]);

      dispatch(SHOW_PROGRESS, "Saving file...", { root: true });
      await saveFile(
        fileName,
        {
          header: uptFile.header,
          xmlData: uptFile.xmlData,
          pickData
        },
        override
      );
      dispatch(HIDE_PROGRESS, null, { root: true });
      commit(FILE_SAVED);
      if (rootState.settings.callbackUrlAfterSave) {
        axios.post(rootState.settings.callbackUrlAfterSave, { 
          filepath: fileName 
        });
      }
      if (!rootState.settings.redirectAfterSave) {
        successNotification("File saved successfully.");
      } else {
        successNotification(
          "File saved successfully. Redirecting to MÜCLOUD..."
        );
        await new Promise(resolve => {
          setTimeout(resolve, 1000);
        });
        window.location.href = rootState.settings.redirectUrlAfterSave;
      }
    } catch (err) {
      console.log(err);
      errorNotification("Failed to save file. Please try again.");
      return false;
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
    return true;
  },

  async [_CREATE_NEW_FILE](
    { commit },
    { nrOfPicks, nrOfJacquardHooks, nrOfShafts, filename }
  ) {
    commit(RESET_STATE);
    uptFile.reset();
    selection.resetSelection(true);
    commit(SET_FILE_NAME, filename);
    commit(SET_FILE_TYPE, "upt128");
    uptFile.createNewUptFile(nrOfPicks, nrOfJacquardHooks, nrOfShafts);
    commit(SET_DATA_AVAILABLE, true);
    commit(SET_MODIFIED, true);
    successNotification("New file created.");
    eventBus.$emit("fileLoaded");
    eventBus.$emit("fullUpdate");
  },
  async [_ADD_DRIVE]({ commit, dispatch }, drive) {
    try {
      dispatch(SHOW_PROGRESS, "Adding drive...", { root: true });
      uptFile.addDrive(drive);
      commit(SET_MODIFIED, true);
      successNotification("Drive added successfully");
    } catch (err) {
      errorNotification("Failed to add drive.");
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
  },
  async [_REMOVE_DRIVE]({ commit, dispatch }, driveIndex) {
    try {
      dispatch(SHOW_PROGRESS, "Removing drive...", { root: true });
      uptFile.removeDrive(driveIndex);
      commit(SET_MODIFIED, true);
      successNotification("Drive removed successfully.");
    } catch (err) {
      errorNotification("Failed to remove drive.");
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
  },
  async [_MOVE_DRIVES]({ commit, dispatch }, { fromIndex, toIndex }) {
    try {
      dispatch(SHOW_PROGRESS, "Moving drives...", { root: true });
      uptFile.moveDrives(fromIndex, toIndex);
      commit(SET_MODIFIED, true);
      successNotification("Drives moved successfully.");
    } catch (err) {
      errorNotification("Failed to move drives.");
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
  },
  [_INSERT_PICKS]({ commit }, { index, quantity }) {
    uptFile.insertPicks(index, quantity);
    commit(SET_MODIFIED, true);
    selection.resetSelection();
    eventBus.$emit("fullUpdate", { retainScrollPosition: true });
    successNotification("Picks inserted successfully.");
  },
  async [_REMOVE_PICKS]({ commit, dispatch }, { index, quantity }) {
    try {
      dispatch(SHOW_PROGRESS, "Removing picks...", { root: true });
      uptFile.deletePicks(index, quantity);
      commit(SET_MODIFIED, true);
      selection.resetSelection();
      eventBus.$emit("fullUpdate", { retainScrollPosition: true });
      successNotification("Picks removed successfully.");
    } catch (err) {
      errorNotification("Failed to remove picks");
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
  },
  async [_REMOVE_PICKS_FROM_SELECTION]({ commit, dispatch }) {
    try {
      dispatch(SHOW_PROGRESS, "Removing picks...", { root: true });
      const picksToRemove = _.uniq(selection.selectionList.map(s => s[0]));
      uptFile.deletePicksFromSelection(picksToRemove);
      commit(SET_MODIFIED, true);
      selection.resetSelection();
      eventBus.$emit("fullUpdate", { retainScrollPosition: true });
      successNotification("Picks removed successfully.");
    } catch (err) {
      errorNotification("Failed to remove picks");
    } finally {
      dispatch(HIDE_PROGRESS, null, { root: true });
    }
  },
  async [_EDIT_SHAFT_JACQUARD]({ commit, dispatch }) {
    let numberOfJacquardHooks = 0;
    if (!_.isEmpty(uptFile.pickData.jacquardData.data)) {
      numberOfJacquardHooks = uptFile.pickData.jacquardData.data[0].length;
    }
    let numberOfShafts = 0;
    if (!_.isEmpty(uptFile.pickData.shaftData.data)) {
      numberOfShafts = uptFile.pickData.shaftData.data[0].length;
    }
    const result = await dispatch(
      NEW_GENERIC_INPUT_DIALOG,
      {
        title: "Edit Jacquard and Shaft",
        okText: "Edit Jacquard and Shaft",
        icon: "$vuetify.icons.editJacShaft",
        autofocus: "numberOfJacquardHooks",
        content: [
          {
            id: "numberOfJacquardHooks",
            type: "numberInput",
            initialValue: numberOfJacquardHooks,
            inputLabel: "# of jacquard hooks",
            min: 0,
            max: 3072,
            createHint: v => {
              if (v % 8 === 0) {
                return "";
              } else {
                return `${v} is not dividable by 8. Will be set to ${Math.ceil(
                  v / 8
                ) * 8}`;
              }
            }
          },
          {
            id: "numberOfShafts",
            type: "numberInput",
            initialValue: numberOfShafts,
            inputLabel: "# of shafts",
            min: 0,
            max: 32
          }
        ]
      },
      { root: true }
    );
    if (result.cancelled) {
      return;
    }
    result.numberOfJacquardHooks =
      Math.ceil(result.numberOfJacquardHooks / 8) * 8;
    if (
      numberOfJacquardHooks !== result.numberOfJacquardHooks ||
      numberOfShafts !== result.numberOfShafts
    ) {
      commit(SET_SHAFT_JACQUARD, {
        oldNumberOfJacquardHooks: numberOfJacquardHooks,
        newNumberOfJacquardHooks: result.numberOfJacquardHooks,
        oldNumberOfShafts: numberOfShafts,
        newNumberOfShafts: result.numberOfShafts
      });
      commit(SET_MODIFIED, true);
    }
  },
  [_TOGGLE_REGULATOR]({ commit }, { pickIndex, currentValue }) {
    const newValue = currentValue === 1 ? 0 : 1;

    const picksToUpdate = [];

    const currentPacket = getPickIndexesOfPacket(uptFile, pickIndex);
    picksToUpdate.push(...currentPacket);

    try {
      if (newValue) {
        const previousPacket = getPickIndexesOfPacket(uptFile, pickIndex - 1);
        picksToUpdate.push(...previousPacket);
        if (picksToUpdate.length > 256) {
          throw "pickPacketTooLarge";
        }
        const newPacketSize = picksToUpdate.length;
        const takeOffUpdate = updateTakeOff(uptFile, pickIndex, picksToUpdate);
        if (takeOffUpdate) {
          commit(SET_EDIT_VALUES, { ...takeOffUpdate, notification: false });
        }
        commit(SET_REGULATOR, { pickIndex, newValue });
        commit(SET_CPPP, { picksToUpdate, newPacketSize });
      } else {
        const indexToSplit = currentPacket.findIndex(p => p === pickIndex);
        const firstPacket = currentPacket.slice(0, indexToSplit);
        const secondPacket = currentPacket.slice(indexToSplit);
        if (picksToUpdate.length > 256) {
          throw "pickPacketTooLarge";
        }
        const takeOffUpdateFirstPacket = updateTakeOff(
          uptFile,
          pickIndex,
          firstPacket
        );
        if (takeOffUpdateFirstPacket) {
          commit(SET_EDIT_VALUES, {
            ...takeOffUpdateFirstPacket,
            notification: false
          });
        }
        const takeOffUpdateSecondPacket = updateTakeOff(
          uptFile,
          pickIndex,
          secondPacket
        );
        if (takeOffUpdateSecondPacket) {
          commit(SET_EDIT_VALUES, {
            ...takeOffUpdateSecondPacket,
            notification: false
          });
        }
        commit(SET_REGULATOR, { pickIndex, newValue });
        commit(SET_CPPP, {
          picksToUpdate: firstPacket,
          newPacketSize: firstPacket.length
        });
        commit(SET_CPPP, {
          picksToUpdate: secondPacket,
          newPacketSize: secondPacket.length
        });
      }
      commit(SET_MODIFIED, true);
    } catch (err) {
      if (err === "pickPacketTooLarge") {
        errorNotification("Pick packets can not be larger than 256");
      } else if (err === "invalidRegulator") {
        errorNotification("Can not set every regulator to true");
      }
    }

    picksToUpdate.forEach(i => {
      eventBus.$emit("pickUpdate", { index: i });
    });
  },

  [_FILE_MODIFIED]({ commit }) {
    commit(SET_MODIFIED, true);
  }
};

function updateTakeOff(data, initialPick, picksToUpdate) {
  const takeOffIndex = data.pickData.driveData.tagNames.findIndex(
    t => t === "PickDensityPer100m"
  );
  if (takeOffIndex !== -1) {
    const newTakeOff = data.pickData.driveData.data[initialPick][takeOffIndex];
    return {
      values: picksToUpdate.map(() => newTakeOff),
      selections: picksToUpdate.map(p => [p, takeOffIndex])
    };
  }
  return null;
}

function getPickIndexesOfPacket(data, pickIndex) {
  if (pickIndex === -1) {
    pickIndex = data.xmlData.patternPicksCount - 1;
  }
  const indexes = [];
  indexes.push(pickIndex);
  const packetSize = data.pickData.colorControl.data[pickIndex][2];

  let currentPickIndex = pickIndex - 1;
  if (currentPickIndex === -1) {
    currentPickIndex = data.xmlData.patternPicksCount - 1;
  }
  if (data.pickData.colorControl.data[pickIndex][1] === 1) {
    while (currentPickIndex >= 0) {
      indexes.unshift(currentPickIndex);
      if (!data.pickData.colorControl.data[currentPickIndex][1]) {
        break;
      }
      currentPickIndex--;
      if (currentPickIndex === -1) {
        currentPickIndex = data.xmlData.patternPicksCount - 1;
      }
    }
  }
  currentPickIndex = pickIndex + 1;
  if (currentPickIndex === data.xmlData.patternPicksCount) {
    currentPickIndex = 0;
  }
  while (
    currentPickIndex < data.xmlData.patternPicksCount &&
    indexes.length < data.xmlData.patternPicksCount
  ) {
    if (!data.pickData.colorControl.data[currentPickIndex][1]) {
      break;
    }
    indexes.push(currentPickIndex);
    currentPickIndex++;
    if (currentPickIndex === data.xmlData.patternPicksCount) {
      currentPickIndex = 0;
    }
  }

  if (indexes.length !== packetSize) {
    throw "inconsistentPacketSize";
  } else if (indexes.length === data.xmlData.patternPicksCount) {
    throw "invalidRegulator";
  }
  return indexes;
}
